import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream-50/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-171">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-172">
        <div className="flex items-center gap-2" data-id="element-173">
          <div className="bg-brand-blue text-white p-1.5 rounded-lg" data-id="element-174">
            <BookOpen size={20} data-id="element-175" />
          </div>
          <span className="font-heading font-bold text-xl text-brand-dark" data-id="element-176">
            IA Fácil y Práctica
          </span>
        </div>
        <a href="#precio" className="bg-brand-orange hover:bg-brand-orangeHover text-white px-5 py-2.5 rounded-full font-semibold text-sm transition-colors shadow-sm hover:shadow-md" data-id="element-177">
          Comprar ahora
        </a>
      </div>
    </motion.header>;
}